import React, { useRef, useCallback } from "react";
import classnames from "classnames";
import { Header } from "./components/Header/Header";
import List from "./components/List/List";
import Map from "./components/Map/Map";
import { useSearchContext } from "./useSearchContext";
import MobileFilters from "./components/MobileFilters/MobileFilters";
import { useFooterVisibilityProcessing } from "./hooks";
import Spinner, { SpinnerBack } from "../Spinner/Spinner";
import { useGoogleMaps } from "../GoogleMapsProvider";
import PageError from "../PageError/PageError";
import { useMapSize } from "components/Search/components/Map/hooks/useMapSize";
import classes from "./Search.module.css";
import { useRvPriceTotalTableInfo } from "components/RvPriceTotalTableInfo/hooks";
import { PriceFormModal } from "components/PriceForm";
import { getFilterRentalType } from "components/Search/utils";

export const Search = () => {
  const { loading: priceTableLoading, modalState, handleClose, onPriceTotalClick } = useRvPriceTotalTableInfo();
  const mapContainer = useRef();
  const {
    error,
    loading,
    mapOpen,
    isMobileFilters,
    filtersWatch
  } = useSearchContext();
  const { isLoaded: isMapLoaded } = useGoogleMaps();
  const { rentalType } = filtersWatch();
  useFooterVisibilityProcessing(mapOpen);

  useMapSize(mapContainer);

  const handleOnPriceTotalClick = useCallback((e, dates) => {
    const { standard, deliveryOnly } = rentalType;
    onPriceTotalClick(e, dates, getFilterRentalType({ standard, deliveryOnly }));
  }, [onPriceTotalClick, rentalType]);

  if (loading || !isMapLoaded) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner position="absolute" />
      </div>
    );
  }

  if (error) {
    return (
      <PageError error={error} />
    );
  }

  return (
    <div
      className={classnames(
        classes.wrapper,
        mapOpen ? classes.isMapOpen : classes.isMapClosed
      )}
    >
      <>
        {priceTableLoading && <SpinnerBack />}
        {modalState.show && modalState.priceForm && !priceTableLoading && (
          <PriceFormModal
            show={modalState.show}
            title="Price breakdown"
            data={[modalState.priceForm]}
            onClose={handleClose}
            isFooter={false}
            isRvPriceTableInfo
          />
        )}
      </>
      <div
        ref={mapContainer}
        className={classnames(
          classes.map,
          mapOpen ? classes.isMapOpen : classes.isMapClosed
        )}
        data-testid="SearchMap"
      >
        <div className={classes.mapInner}>
          <Map withControls onPriceTotalClick={handleOnPriceTotalClick} />
        </div>
      </div>
      <div
        className={classes.root}
      >
        <div className={classes.content}>
          <Header />
          <List className={classes.list} onPriceTotalClick={handleOnPriceTotalClick} />
        </div>

        {isMobileFilters && (
          <MobileFilters />
        )}
      </div>
    </div>
  );
};
